/**
 * @author Fernando Tapia <ftapia@pensare.mx>
 * @version 1.0.0
 * @file Manages the configuration settings for the routes.
 */
import React, {Component} from 'react';
import {Route} from 'react-router-dom';


import TemporalAccess from '../scene/temporalAccess.js';

import Direction from '../scene/profile/direction';
import DirectionHome from '../scene/direction/home';
import PlaceDirection from '../scene/direction/placeDirection';

import Client from '../scene/profile/client';
import PlaceClient from '../scene/client/placeClient';
import GisClient from '../scene/client/gis';

import Operation from '../scene/profile/operation';
import OperationHome from '../scene/operation/home';
import PlaceOperation from '../scene/operation/placeOperation';
import PerformanceOperation from '../scene/operation/performanceOperation';
import OptimizationMonitoring from '../scene/operation/optimizationMonitoring'

import Management from '../scene/profile/management';
import PlaceManagement from '../scene/management/placeManagement';
import ManagementHome from '../scene/management/home';

import SupervisorHome from '../scene/supervisor/home';

import ContactCenter from '../scene/common/contactCenter';
import Quality from '../scene/quality/quality';
import Directory from '../scene/directory/directory';
import HumanResources from '../scene/human-resources/humanResources';
import News from '../scene/news/news';
import NewBusiness from '../scene/new-business/newBusiness';


/**
 * Class representing a RoutesComponent.
 */
class RoutesComponent extends Component {
  render() {
    return (
      <div>
        <Route exact path="/" component={TemporalAccess}/>
        <Route path="/direction" component={Direction}/>
        <Route path="/direction-home/:vp" component={DirectionHome}/>
        <Route path="/profile-direction/place/:vp" component={PlaceDirection}/>
        <Route path="/client" component={Client}/>
        <Route path="/profile-client/place/:vp" component={PlaceClient}/>
        <Route path="/profile-client/gis/:vp" component={GisClient}/>
        <Route path="/operation" component={Operation}/>
        <Route path="/operation-home/:vp" component={OperationHome}/>
        <Route path="/profile-operation/place/:vp" component={PlaceOperation}/>
        <Route path="/profile-operation/performance-analysis/:vp" component={PerformanceOperation}/>
        <Route path="/profile-operation/optimization-monitoring/:vp" component={OptimizationMonitoring}/>
        <Route path="/management" component={Management}/>
        <Route path="/profile-management/place/:vp" component={PlaceManagement}/>
        <Route path="/management-home/:vp" component={ManagementHome}/>
        <Route path="/supervisor-home/:vp" component={SupervisorHome}/>
        <Route path="/contact-center" component={ContactCenter}/>
        <Route path="/quality" component={Quality}/>
        <Route path="/directory" component={Directory}/>
        <Route path="/human-resources" component={HumanResources}/>
        <Route path="/news" component={News}/>
        <Route path='/new-business' component={NewBusiness}/>
      </div>
    );
  }
}

export default RoutesComponent;



// WEBPACK FOOTER //
// ./src/routers/routesComponent.js